import React, { useEffect, useState } from "react";
import { Carousel } from "react-bootstrap";
import PropTypes from 'prop-types';
import { IconButton } from "@mui/material";
import { PauseCircleFilledOutlined as PauseCircleFilledOutlinedIcon } from '@mui/icons-material';
import { ChevronLeft as ChevronLeftIcon } from '@mui/icons-material';
import { ChevronRight as ChevronRightIcon } from '@mui/icons-material';
import { PlayCircleFilled as PlayCircleFilledIcon } from '@mui/icons-material';
import './AutoCarousel.scss';

export default function AutoCarousel(props) {
  const [index, setIndex] = useState(0);
  const [autoPlay, setAutoPlay] = useState(true);

  const handleSelect = (selectedIndex, event, isFromIndicator = false) => {
    if (!autoPlay && !isFromIndicator) {return;}
    setIndex(selectedIndex);
  };

  const toggleSlider = () => {
    setAutoPlay(!autoPlay);
  };

  useEffect(() => {
    if (props.isHasIndicator && index === (props.rotatingSteps && props.rotatingSteps.length - 1)) {
      setAutoPlay(false);
    }
  }, [index]);

  const goToPrevStep = () => {
    if (index === 0) {
      setIndex(props.rotatingSteps && props.rotatingSteps.length - 1);
    }
    else {
      setIndex(index - 1);
    }
  };

  const goToNextStep = () => {
    if (index === props.rotatingSteps && props.rotatingSteps.length - 1) {
      setIndex(0);
    }
    else {
      setIndex(index + 1);
    }
  };

  const handleKeyDown = (e) => {
    const items = props.data;
    if (e.keyCode === 37) {
      if (index === 0) {
        setIndex(items.length - 1);
      } else {
        setIndex(index - 1);
      }
    }
    else if (e.keyCode === 39) {
      if (index === items.length - 1) {
        setIndex(0);
      } else {
        setIndex(index + 1);
      }
    }
  };

  const intervalValue = props.isHasIndicator ? (autoPlay ? 8000 : null) : 5000;

  return (
    <div className="auto-carousel px-0">
      <Carousel indicators={false} keyboard={true} tabIndex='0' interval={intervalValue} activeIndex={index} onSelect={handleSelect}>
        {props.data.map((d, i) =>
          <Carousel.Item key={i}>
            {d}
          </Carousel.Item>
        )}
      </Carousel>
      {props.isHasIndicator &&
      <div className="text-center">
        <IconButton onClick={goToPrevStep} className="px-0" disableRipple size="large">
          <ChevronLeftIcon />
        </IconButton>
        <IconButton
          onClick={goToNextStep}
          disabled={index === props.rotatingSteps.length - 1}
          className="px-0"
          disableRipple
          size="large">
          <ChevronRightIcon />
        </IconButton>
      </div>
      }
      {props.showPlayButton ?
        <div className="help-me-decide-carousel">
          <ol className="carousel-indicators">
            {props.data.map((item, i) => {
              return (<li
                aria-label={`quote ${i}`}
                key={i}
                className={index === i ? "active" : ""}
              >
                <button onKeyDown={(e) => handleKeyDown(e)} aria-label={i} tabIndex="0" role="button" id={i} onClick={(e) => handleSelect(i, e, true)} />
              </li>);
            })}
          </ol>
        </div>
        : ''}
      {props.showPlayButton ?
        <div className='button-toggle'>
          <button className="buttonToggle" onClick={toggleSlider} id="toggleCarousel" aria-label={autoPlay ? "play" : "pause"}>{autoPlay ? <span><PauseCircleFilledOutlinedIcon /></span> : <span><PlayCircleFilledIcon /></span>}</button>
        </div>
        : ''}
    </div >
  );
}

AutoCarousel.propTypes = {
  data: PropTypes.array.isRequired,
  rotatingSteps: PropTypes.array,
  isHasIndicator: PropTypes.bool,
  showPlayButton: PropTypes.bool,
};
